export function variantForWorkgroup(workgroup) {
  if (!workgroup) {
    return 'secondary';
  }

  let variant;
  if (workgroup.type === 'ADMINISTRATOR') {
    variant = 'primary';
  } else if (workgroup.type === 'ORDINARY') {
    variant = 'success';
  } else if (workgroup.type === 'GUEST') {
    variant = 'warning';
  }
  return variant;
}

export function helpForWorkgroup(workgroup) {
  if (!workgroup) {
    return undefined;
  }

  let help;
  if (workgroup.type === 'ADMINISTRATOR') {
    help = `Sei amministratore del gruppo ${workgroup.name}`;
  } else if (workgroup.type === 'ORDINARY') {
    help = `Sei utente ordinario del gruppo ${workgroup.name}`;
  } else if (workgroup.type === 'GUEST') {
    help = `Sei ospite del gruppo ${workgroup.name}`;
  }
  return help;
}

export function tagForWorkgroup(workgroup) {
  const text = workgroup.name;
  const variant = variantForWorkgroup(workgroup);
  const help = helpForWorkgroup(workgroup);
  return {
    value: text,
    variant,
    tooltip: help
  };
}
